








































































import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { PropType } from 'vue';
import { ShopListItem, ShopType } from '@tt4b/ttam-enums';
import { i18n } from './../../../../i18n';
import { isShopAdmin, getStoreManagerUrl } from '../utils';
import backupImg from '@/components/common/back-img/index.vue';
import BCLogo from '@tt4b/ttam-assets/src/images/bc-logo.png';

const name = 'ttam-product-source-shop-item';
export default defineComponent({
  name,
  components: {
    backupImg,
  },
  props: {
    source: {
      type: Object as PropType<ShopListItem>,
      default: () => ({}),
    },
    onClick: {
      type: Function as PropType<(i: ShopListItem) => void>,
      default: () => () => undefined,
    },
    currentItem: {
      type: Object as PropType<ShopListItem>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { source, currentItem } = toRefs(props);
    const isSelectedItem = computed(
      () => currentItem.value.id === source.value.id && currentItem.value.bc_id === source.value.bc_id,
    );
    // 1p才需要显示shop code
    const isShowShopCode = ({ type, oec_shop_code }) => type === ShopType.ecommShop && oec_shop_code;
    return {
      name,
      BCLogo,
      i18n,
      isSelectedItem,
      isShopAdmin,
      getStoreManagerUrl,
      isShowShopCode,
    };
  },
});
